export default __webpack_public_path__ + "static/media/payment-screen-2.dca0dabe.png";